<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Economical Writing</h1>
<h1 class="bk1">THIRD EDITION</h1>
<h1 class="bk2">Thirty-Five Rules for Clear and Persuasive Prose</h1>
<p class="bkau">Deirdre Nansen McCloskey</p>
<p class="bkau1"><i>With an Appendix by</i> STEPHEN T<span class="sm">.</span> ZILIAK</p>
<p class="bkpub">THE UNIVERSITY OF CHICAGO PRESS</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mccloskey-0004.vue?37bfc25c